import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { SiGoogle, SiFacebook } from "react-icons/si";
import { Building2 } from "lucide-react";

interface OAuthLoginProps {
  title?: string;
  description?: string;
  showTraditionalLogin?: boolean;
  onTraditionalLogin?: () => void;
}

export function OAuthLogin({ 
  title = "Sign in to GCEP", 
  description = "Choose your preferred sign-in method",
  showTraditionalLogin = true,
  onTraditionalLogin 
}: OAuthLoginProps) {
  const apiURL = import.meta.env.VITE_API_URL || "http://localhost:4001";

  const handleOAuthLogin = (provider: string) => {
    const providerPath: Record<string, string> = {
      google: "google",
      facebook: "oauth/facebook",
      microsoft: "oauth/microsoft",
    };
    const path = providerPath[provider] || provider;
    window.location.href = `${apiURL}/api/auth/${path}`;
  };

  return (
    <Card className="w-full max-w-md mx-auto">
      <CardHeader className="space-y-1">
        <CardTitle className="text-2xl text-center">{title}</CardTitle>
        <CardDescription className="text-center">
          {description}
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        {/* OAuth Login Buttons */}
        <div className="space-y-3">
          <Button
            variant="outline"
            className="w-full flex items-center justify-center gap-3 h-11"
            onClick={() => handleOAuthLogin('google')}
          >
            <SiGoogle className="w-5 h-5 text-red-500" />
            Continue with Google
          </Button>
          
          {/* <Button
            variant="outline"
            className="w-full flex items-center justify-center gap-3 h-11"
            onClick={() => handleOAuthLogin('facebook')}
          >
            <SiFacebook className="w-5 h-5 text-blue-600" />
            Continue with Facebook
          </Button> */}
          
          {/* <Button
            variant="outline"
            className="w-full flex items-center justify-center gap-3 h-11"
            onClick={() => handleOAuthLogin('microsoft')}
          >
            <Building2 className="w-5 h-5 text-blue-500" />
            Continue with Microsoft
          </Button> */}
        </div>

        {/* Separator */}
        {showTraditionalLogin && (
          <>
            <div className="relative">
              <div className="absolute inset-0 flex items-center">
                <Separator className="w-full" />
              </div>
              <div className="relative flex justify-center text-xs uppercase">
                <span className="bg-background px-2 text-muted-foreground">
                  Or continue with
                </span>
              </div>
            </div>

            {/* Traditional Login Button */}
            <Button
              variant="default"
              className="w-full h-11"
              onClick={onTraditionalLogin}
            >
              Email & Password
            </Button>
          </>
        )}
      </CardContent>
    </Card>
  );
}